<template>
  <div class="relative">
    <div :class="hasError ? `error_error ${errorBtn ? 'error_btn' : ''}` : ''">
      {{ error }}
    </div>
    <div
      :class="
        hasError
          ? '_custom_full_width custom_error'
          : `_custom_full_width ${errorBtn ? '' : 'hover'}`
      "
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasError: {
      type: Boolean,
      default: false,
    },
    errorBtn: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.hover:hover {
  transition: background-color 0.3s ease-in-out;
}
.hover:hover {
  background-color: var(--v-gray-base);
}
.relative {
  position: relative;
}
.relative .error_error {
  position: absolute;
  width: min-content;

  font-weight: bold;
  color: orangered;
  top: -15px;
  width: 100%;
}
.error_error.error_btn {
  top: -3px !important;
  z-index: 1;
  background-color: #ffffff70;
  height: min-content;
}
.custom_error {
  background-color: #fbdfde !important;
  width: 100% !important;
  border-radius: 3px;
}
._custom_full_width {
  width: 100% !important;
}
</style>
